import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import {
  Button,
  ButtonWrapper,
  Container,
  MatchStartTime,
  Status,
  TeamLogo,
  TeamNameWrapper,
  TeamWrapper,
  TitleWrapper,
  CountDown,
  Score,
  ScoreWrapper,
  StateWrapper,
} from './styled';
import SportsTeamLogo from '../../../teamLogo';
import BaseballBoxScore from './BoxScore';
import { toJS } from 'mobx';
import { getStreamBrowser } from '../../../../routes/score/liveStream/util';

const BaseballMatch = observer(({ gameData }) => {
  const { detail } = gameData;

  const {
    teams,
    season,
    gameStatus,
    startDatetime,
    videoLink,
    betbleButtonVisible,
    betbleUri,
    sportsType,
    champGameId,
  } = detail;

  const homeTeam = teams.home;
  const awayTeam = teams.away;

  const formattedDateTime = moment(startDatetime).locale('ko').format('MM.DD (ddd) HH:mm');

  const handleClickBetbleLink = () => {
    let type = 0;

    if (detail.getTracker.status === 'progress') {
      type = 1;
    }
    const url = `https://betble.com/game/game.php?type=${type}${betbleUri}`;
    window.open(url);
  };

  const onClickVideo = () => {
    getStreamBrowser(videoLink);
  };

  return (
    <Container>
      <TitleWrapper>
        <TeamWrapper>
          <TeamLogo>
            <SportsTeamLogo imgSize={'70'} imgUrl={homeTeam.imgPath} isLazy={true} />
          </TeamLogo>
          <TeamNameWrapper>
            <p>{homeTeam.name}</p>
            <span>
              {season.name} {homeTeam.seasonRecord.ranking > 0 && `${homeTeam.seasonRecord.ranking}위`}
            </span>
          </TeamNameWrapper>
        </TeamWrapper>
        <Status>
          {gameStatus === 'READY' && <CountDownComp detail={detail} />}
          {gameStatus !== 'READY' && <ScoreComp detail={detail} />}

          <MatchStartTime>{formattedDateTime}</MatchStartTime>
          <ButtonWrapper>
            {/*{!!champGameId && (*/}
            {/*  <Button*/}
            {/*    champ*/}
            {/*    href={`https://champscore.com/${sportsType.toLowerCase()}/${champGameId}`}*/}
            {/*    target={'_blank'}*/}
            {/*  >*/}
            {/*    챔프*/}
            {/*  </Button>*/}
            {/*)}*/}
            {videoLink && (gameStatus === 'IN_PROGRESS' || gameStatus === 'BREAK_TIME' || gameStatus === 'PAUSE') && (
              <Button onAir={'true'} onClick={onClickVideo} target={'_blank'}>
                생중계
              </Button>
            )}
            {betbleButtonVisible && (
              <Button onClick={handleClickBetbleLink} betble>
                베팅하기
              </Button>
            )}
          </ButtonWrapper>
        </Status>
        <TeamWrapper>
          <TeamLogo>
            <SportsTeamLogo imgSize={'70'} imgUrl={awayTeam.imgPath} isLazy={true} />
          </TeamLogo>
          <TeamNameWrapper>
            <p>{awayTeam.name}</p>
            <span>
              {season.name} {awayTeam.seasonRecord.ranking > 0 && `${awayTeam.seasonRecord.ranking}위`}
            </span>
          </TeamNameWrapper>
        </TeamWrapper>
      </TitleWrapper>

      <BaseballBoxScore detail={detail} />
    </Container>
  );
});

const CountDownComp = observer(({ detail }) => {
  return <CountDown>{detail.getCountDownTime}</CountDown>;
});

const ScoreComp = observer(({ detail }) => {
  const { homeTotalScore, awayTotalScore, gameStatus } = detail;
  return (
    <ScoreWrapper>
      <Score winPosition={homeTotalScore > awayTotalScore}>{homeTotalScore}</Score>
      <StateWrapper>
        <span>{detail.statusText}</span>
        {gameStatus === 'IN_PROGRESS' && <span>{detail.displayTime}</span>}
      </StateWrapper>
      <Score winPosition={awayTotalScore > homeTotalScore}>{awayTotalScore}</Score>
    </ScoreWrapper>
  );
});

export default BaseballMatch;
